<template>
  <div class="my-order-wrap">
    <div class="work-order-list-wrap" v-if="!isCheck">
      <div class="work-order-list">
        <div class="title-wrap">
          <span class="title">{{ $t('app.auto_62_b7fb536e') }}</span>
          <span class="close" @click="closeMyOrderList"
            ><i class="el-icon-close"></i
          ></span>
        </div>
        <div v-if="loadFlag1 && loadFlag2">
          <div class="no-data" v-if="!handleData.length && !finishedData.length">
            <p class="text-title">{{ $t('app.auto_63_9c495a0c') }}</p>
            <p>{{ $t('app.auto_64_794b0be6') }}</p>
            <p class="red-color">{{ $t('app.auto_63_9c495a0c') }}</p>
          </div>
          <template v-else>
            <div class="order-type">
              <div class="order-title">
                <span class="title">{{ $t('app.auto_66_4c74e75e') }}</span>
                <el-tooltip placement="right-start">
                  <div slot="content">{{ $t('app.auto_67_99c2c990') }}</div>
                  <i class="el-icon-question question-icon"></i>
                </el-tooltip>
              </div>
              <div class="order-list">
                <template v-if="finishedData.length">
                  <el-table
                    :data="finishedData"
                    stripe
                    border
                    style="width: 100%"
                    :header-cell-style="{
                      background: 'rgb(230, 240, 252)',
                      textAlign: 'center',
                      color: 'black',
                    }"
                    :cell-style="{
                      textAlign: 'center',
                      padding: '0',
                    }"
                  >
                    <!-- <template slot="empty">
                      <el-empty :image-size="70"></el-empty>
                    </template> -->
                    <el-table-column prop="title" :label="$t('pageDecorate.lbl_0bc5794fd2')" width="180" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                      prop="createStaffName"
                      :label="$t('pageDecorate.lbl_0e1bf7ba51')"
                      width="100"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="pushTime"
                      :label="$t('pageDecorate.workOrderSubmitAt')"
                      width="170"
                    ></el-table-column>
                    <el-table-column :label="$t('pageDecorate.lbl_8627bfd5e5')">
                      <template slot-scope="scope">
                        <div class="detail-edit-wrap">
                          <el-button
                            type="text"
                            @click="checkOrderDetail(scope.row)"
                            >{{ $t('app.view') }}</el-button
                          >
                          <span class="new-tip" v-if="scope.row.isUnread">{{ $t('app.auto_68_419e05d6') }}</span>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="page-wrap">
                    <el-pagination
                      layout="total, prev, pager, next, jumper"
                      :total="finishedCount"
                      :pager-count="7"
                      :current-page.sync="finishIndex"
                      :page-size.sync="finishedSize"
                      @size-change="finishedSizeChange"
                      @current-change="finishedIndexChange"
                    >
                    </el-pagination>
                  </div>
                </template>
                <template v-else>
                  <p class="no-data">{{ $t('app.auto_69_31ad8c59') }}</p>
                </template>
              </div>
            </div>
            <div class="order-type">
              <div class="order-title">
                <span class="title">{{ $t('app.auto_70_1ee3a0b3') }}</span>
                <el-tooltip placement="right-start">
                  <div slot="content">{{ $t('app.auto_71_6d2b1005') }}</div>
                  <i class="el-icon-question question-icon"></i>
                </el-tooltip>
              </div>
              <div class="order-list">
                <template v-if="handleData.length">
                  <el-table
                    :data="handleData"
                    stripe
                    border
                    style="width: 100%"
                    :header-cell-style="{
                      background: 'rgb(230, 240, 252)',
                      textAlign: 'center',
                      color: 'black',
                    }"
                    :cell-style="{
                      textAlign: 'center',
                      padding: '0',
                    }"
                  >
                    <!-- <template slot="empty">
                      <el-empty :image-size="70"></el-empty>
                    </template> -->
                    <el-table-column prop="title" :label="$t('pageDecorate.lbl_0bc5794fd2')" width="180" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                      prop="createStaffName"
                      :label="$t('pageDecorate.lbl_0e1bf7ba51')"
                      width="100"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="pushTime"
                      :label="$t('pageDecorate.workOrderSubmitAt')"
                      width="170"
                    ></el-table-column>
                    <el-table-column :label="$t('pageDecorate.lbl_8627bfd5e5')">
                      <template slot-scope="scope">
                        <div class="detail-edit-wrap">
                          <el-button type="text" @click="checkOrderDetail(scope.row)"
                            >{{ $t('app.view') }}</el-button
                          >
                          <!-- <span class="new-tip"></span> -->
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="page-wrap">
                    <el-pagination
                      layout="total, prev, pager, next, jumper"
                      :pager-count="7"
                      :total="handleCount"
                      :current-page.sync="handleIndex"
                      :page-size.sync="handleSize"
                      @size-change="handleSizeChange"
                      @current-change="handleIndexChange"
                    >
                    </el-pagination>
                  </div>
                </template>
                <template v-else>
                  <p class="no-data">{{ $t('app.auto_72_794828ac') }}</p>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 工单详情 -->
    <div class="order-detail-wrap work-order-list-wrap" v-show="isCheck">
      <div class="title-wrap">
        <span class="title">{{ $t('app.auto_73_32adfc8d') }}</span>
        <span class="close" @click="closeOrderDetail"
          ><i class="el-icon-close"></i
        ></span>
      </div>
      <div class="detail-list">
        <h3 class="titleSty">{{ $t('app.auto_74_f6fd4c00') }}</h3>
        <table style="margin-top: 10px;">
           <tr>
            <td class="tip">{{ $t('app.auto_75_95cc1a8c') }}</td>
            <td class="content">{{orderDetailData.sheetId}}</td>
          </tr>
          <tr>
            <td class="tip">{{ $t('app.auto_76_40dca735') }}</td>
            <td class="content">{{orderDetailData.title}}</td>
          </tr>
          <tr>
            <td class="tip">{{ $t('app.auto_77_39620e02') }}</td>
            <td class="content">{{orderDetailData.createStaffName}}</td>
          </tr>
          <tr>
            <td class="tip">{{ $t('app.auto_78_0d0b0047') }}</td>
            <td class="content">{{orderDetailData.pushTime}}</td>
          </tr>
          <tr>
            <td class="tip">{{ $t('app.auto_79_bd9cd84d') }}</td>
            <td class="content">
              <span :class="`${orderDetailData.sheetStatus == 2 ? 'finished' : 'handing'}`">
                {{orderDetailData.sheetStatus == 2 ? this.$t('app.auto_389_c72ec969') : this.$t('app.auto_390_9c90503b')}}</span>
              <!-- <span class="handing"></span> -->
            </td>
          </tr>
          <tr>
            <td class="tip">{{ $t('app.auto_80_0cf9382a') }}</td>
            <td class="content">{{orderDetailData.handleStaffName}}</td>
          </tr>
          <tr v-if="orderDetailData.sheetStatus == 2" >
            <td class="tip">{{ $t('app.auto_81_3ac0816a') }}</td>
            <td class="content">{{orderDetailData.overTime || '-'}}</td>
          </tr>
        </table>
      </div>
      <div class="handle-result">
        <h3 class="titleSty">{{ $t('app.auto_82_403c2cbf') }}</h3>
        <div class="result">
          <template v-if="orderDetailData.sheetStatus == 2">
            <!-- 已处理 -->
            <p class="idea">
              {{orderDetailData.resultRemark}}
            </p>
            <div class="file-list">
              <div class="file-item" v-for="(item,index) in orderDetailData.sheetFileList" :key="index" @click="previewFile(item)">
                <!-- <a :href="item.fileUrl" target="_blank"> -->
                  <div class="file-icon">
                    <img v-if="item.type == 'img'" :src="item.fileUrl" alt=""/>
                    <img v-if="item.type == 'pdf'" src="./images/pdf.png" alt=""/>
                    <img v-if="item.type == 'ppt'" src="./images/ppt.png" alt=""/>
                    <img v-if="item.type == 'doc'" src="./images/doc.png" alt=""/>
                    <img v-if="item.type == 'xls'" src="./images/xls.png" alt=""/>
                    <img v-if="item.type == 'video'" src="./images/video.png" alt=""/>
                  </div>
                  <div class="file-name">{{item.fileName}}</div>
                <!-- </a> -->
              </div>
            </div>
          </template>
          <template v-else>
            <!-- 未处理 -->
            <p class="idea">{{ $t('app.auto_83_2933c8fe') }}</p>
          </template>
        </div>
      </div>
    </div>
    <div v-if="dialogVisible" class="preview-wrap" @click="dialogVisible=false">
      <!-- <iframe class="" :src="previewFileUrl" frameborder="0"></iframe> -->
      <!-- <embed :src="previewFileUrl" type="application/pdf" width="100%" height="100%"> -->
      <img @click.stop="" class="width-80" v-if="previewFileObj.type == 'img'" :src="previewFileObj.fileUrl" alt="">
      <video @click.stop="" class="width-80" autoplay v-if="previewFileObj.type == 'video'" :src="previewFileObj.fileUrl"></video>
    </div>
  </div>
</template>

<script>
import { queryWorkSheetList, getWorkSheet, updateWorkSheetRead } from "./apis";
export default {
  props: {
    appType: {
      type: String,
      default: 'agent',
    },
  },
  components: {},
  data() {
    return {
      finishedData: [
        // {
        //   titleKey: 'common.系统登录异常问题5',
        //   createStaffName: "张老师",
        //   pushTime: "2023-12-01 10:30:00",
        //   isUnread: true
        // },
        // {
        //   titleKey: 'common.课程视频无法播放6',
        //   createStaffName: "李老师",
        //   pushTime: "2023-11-28 14:20:00",
        //   isUnread: false
        // },
        // {
        //   titleKey: 'common.学生数据导出功能异常7',
        //   createStaffName: "王老师",
        //   pushTime: "2023-11-25 09:15:00",
        //   isUnread: false
        // },
        // {
        //   titleKey: 'common.作业批改系统卡顿8',
        //   createStaffName: "赵老师",
        //   pushTime: "2023-11-20 16:45:00",
        //   isUnread: true
        // },
        // {
        //   titleKey: 'common.课件上传失败问题9',
        //   createStaffName: "刘老师",
        //   pushTime: "2023-11-15 11:30:00",
        //   isUnread: false
        // }
      ], //完结工单数据
      finishedCount: 0,
      finishIndex: 1,
      finishedSize: 3,
      handleData: [], //未完结工单数据
      handleCount: 0,
      handleIndex: 1,
      handleSize: 3,
      loadFlag1:false,
      loadFlag2:false,
      dialogVisible:false,
      previewFileObj:'',
      userInfo: {},
      isCheck: false, //是否在查看工单
      orderDetailData:{},
    };
  },
  computed: {
    // 判断是否为教师类型
    isTeacher() {
      return this.appType === 'teacher';
    },
    // 判断是否为代理商类型
    isAgent() {
      return this.appType === 'agent';
    },
    // 获取用户信息存储的key
    userInfoKey() {
      return this.isTeacher ? 'teacher_info' : `${this.appType}_user_info`;
    },
    // 获取额外的请求参数（教师类型需要添加type:1）
    extraParams() {
      return this.isTeacher ? { type: 1 } : {};
    },
  },
  methods: {
    // 更换table
    // handleClick() {
    //   this.finishIndex = 1;
    //   this.getListData();
    // },
    // 已完结改变size
    finishedSizeChange(size) {
      this.finishIndex = 1;
      this.finishedSize = size;
      this.queryWorkSheetList(2)
    },
    // 已完结改变页
    finishedIndexChange(page) {
      this.finishIndex = page;
      this.queryWorkSheetList(2)
    },
    // 未完结
    handleSizeChange(size) {
      this.handleIndex = 1;
      this.handleSize = size;
      this.queryWorkSheetList(1)
    },
    handleIndexChange(page) {
      this.handleIndex = page;
      this.queryWorkSheetList(1)
    },
    previewFile(item){
      this.previewFileObj = item
      if(item.fileUrl){
        if(item.type == 'pdf'){
          window.open("https://view.xdocin.com/view?src=" + encodeURIComponent(item.fileUrl.split('?')[0])
          );
        } else {
          window.open(item.fileUrl.split('?')[0])
        }
      }
    },
    // 获取完结工单列表
    getListData() {
      this.queryWorkSheetList(1)
      this.queryWorkSheetList(2)
    },
    queryWorkSheetList(type) {
      // 网络请求获取是否有新的工单
      const userId = this.userInfo[this.isTeacher ? 'teacher_id' : 'id'];
      let params = {
        pageIndex: type==1?this.handleIndex:this.finishIndex,
        pageSize: type==1?this.handleSize:this.finishedSize,
        param: {
          userId,
          sheetStatus: type,
          ...this.extraParams
        }
      }
      queryWorkSheetList(params).then((res) => {
        if (res.code == 0) {
          if(type == 1){
            this.handleCount = res.data.count || 0
            this.handleData = res.data.body || []
            this.loadFlag1 = true
          }else{
            this.finishedCount = res.data.count
            this.finishedData = res.data.body || []
            this.loadFlag2 = true
          }
        }
      });
    },
    // 查看工单详情
    checkOrderDetail(item) {
      let params = {
        param: {
          sheetCode: item.sheetCode,
          ...this.extraParams
        }
      }
      getWorkSheet(params).then((res) => {
        if (res.code == 0) {
          res.data.sheetFileList.forEach((item)=>{
            item.type = this.getFileType(item.fileUrl)
            console.log(item.type,999)
          })
          this.orderDetailData = res.data
          this.isCheck = true
          this.updateWorkSheetRead(item)
        }
      });
    },
    getFileType(url){
      let fileType = url.substring(url.lastIndexOf(".") + 1);
      console.log(fileType,99999)
      let type = ''
      if(fileType == "jpg" || fileType =="jpeg" || fileType == "png" || fileType=="svg" || fileType=="bmp"){
        type = 'img'
      }else if(fileType == "video" || fileType == "mp4"){
        type = 'video'
      }else if(fileType == "pdf"){
        type = 'pdf'
      }else if(fileType == "ppt" || fileType == "pptx"){
        type = 'ppt'
      }else if(fileType == "docx" || fileType == "doc"){
        type = 'doc'
      }else if(fileType == "xlsx" || fileType == "xls"){
        type = 'xls'
      }
      return type
    },
    // 工单已读
    updateWorkSheetRead(item) {
      let params = {
        param: {
          sheetCode: item.sheetCode,
          ...this.extraParams
        }
      }
      updateWorkSheetRead(params).then((res) => {});
    },
    closeOrderDetail(){
      this.isCheck = false
      this.getListData()
    },
    // 子组件调用父组件方法，关闭我的工单
    closeMyOrderList() {
      this.$emit("closeMyOrderList");
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem(this.userInfoKey) || '{}');
  },
  mounted() {
    this.getListData();
  },
};
</script>

<style lang="scss" scoped>
.my-order-wrap {
  position: relative;
  width: 598px;
  height: 466px;
  overflow-y: scroll;
  background: #ffffff;
  box-shadow: 0px 6px 12px 0px rgba(68, 75, 101, 0.06);
  border-radius: 8px;
  margin: auto;
  padding: 0 16px 16px;
  &::-webkit-scrollbar {
    display: none;
  }
}
.work-order-list-wrap {
  height: 466px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
}
.work-order-list {
  position: relative;
  .title-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(68, 75, 101, 0.05);
    border-radius: 8px 8px 0px 0px;
    position: sticky;
    top: 0;
    z-index: 3;
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      font-size: 20px;
      color: #444b65;
      line-height: 24px;
      font-style: normal;
    }
    .close {
      font-size: 25px;
      color: #2980ff;
    }
  }
  .no-data{
    text-align: center;
    margin-top: 120px;
    p{
      font-size: 18px;
      color: #696F84;
      line-height: 44px;
    }
    .text-title{
      font-weight: 500;
      font-size: 22px;
      color: #444B65;
    }
    .red-color{
       color: #FF0000;
    }
  }
  .order-type {
    padding: 16px;
    .order-title {
      white-space: nowrap;
      padding: 8px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #444b65;
      line-height: 24px;
      font-style: normal;
      .title {
        white-space: nowrap;
      }
      .question-icon {
        font-size: 18px;
        margin-left: 4px;
      }
    }
    .order-list {
      .detail-edit-wrap {
        position: relative;
        .new-tip {
          position: absolute;
          right: -10px;
          top: 2px;
          height: 18px;
          line-height: 18px;
          padding: 0 4px;
          font-size: 12px;
          color: #fff;
          border-radius: 9px 9px 9px 0px;
          background: #FF4A46;
          z-index: 10;
        }
      }
    }
    .page-wrap {
      margin-top: 12px;
      text-align: center;
      display: flex;
      justify-content: center;
    }
    .no-data {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #444b65;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      margin: 0;
      padding: 4px 8px;
    }
  }
}
.order-detail-wrap {
  // width: 598px;
  // position: absolute;
  // z-index: 3;
  // width: 100%;
  // min-height: 466px;
  // overflow-y: hidden;
  // top: 0;
  // left: 0;
  // background: #fff;
  // padding: 0 16px 16px;
  .title-wrap {
    display: flex;
    width: 566px;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: #ffffff;
    box-shadow: 0px 4px 8px 0px rgba(68, 75, 101, 0.05);
    border-radius: 8px 8px 0px 0px;
    position: sticky;
    top: 0;
    z-index: 3;
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #444b65;
      line-height: 24px;
      font-style: normal;
    }
    .close {
      font-size: 25px;
      color: #2980ff;
    }
  }
  .detail-list {
    padding: 16px;
    table {
      tr {
        height: 36px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #696f84;
        line-height: 24px;
        text-align: left;
        font-style: normal;
      }
      .tip {
        width: 260px;
      }
      .handing {
        color: #ffba00;
      }
      .finished {
        color: #46c93a;
      }
    }
  }
    .titleSty {
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      font-size: 16px;
      color: #444b65;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  .handle-result {
    padding: 0 16px;

    .result {
      margin-top: 16px;
      .idea {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #444b65;
        line-height: 28px;
        text-align: left;
        font-style: normal;
        margin: 0;
        padding: 0;
      }
      .file-list {
        margin-top: 16px;
        display: grid;
        grid-template-columns: repeat(3, 178px);

        .file-item {
          margin-right: 12px;
          margin-bottom: 12px;
          font-size: 14px;
          border: 1px solid #cccccc;
          padding: 4px;
          background: #ffffff;
          border-radius: 4px;
          display: flex;
          flex-direction: row;
          overflow:hidden;
        }
        .file-icon {
          margin-right: 4px;
          img {
            width: 31px;
            height: 39px;
          }
        }
      }
    }
  }
}
.preview-wrap{
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  overflow-y: auto;
  .width-80{
    width: 70%;
    height: auto;
  }
}
:deep(.el-table--border .el-table__cell){
    border-right: 1px solid #ebeef5 !important;
    border-bottom: 1px solid #ebeef5 !important;
}
</style>